import React from 'react';

export default function StarRating({ rating = 0, count, size = 'sm', showCount = true }) {
  const stars = Array.from({ length: 5 }, (_, i) => i < Math.round(rating));
  const sz    = size === 'lg' ? 'text-base' : 'text-xs';

  return (
    <span className="inline-flex items-center gap-0.5">
      {stars.map((filled, i) => (
        <i
          key={i}
          className={`fa-star fa-solid ${sz} ${filled ? 'text-amber-400' : 'text-gray-200'}`}
        />
      ))}
      {showCount && (
        <span className="text-xs text-text-muted ml-1">
          {Number(rating).toFixed(1)}{count !== undefined && ` (${count})`}
        </span>
      )}
    </span>
  );
}
